<template>
  <div class="container-fluid">
    <transition :css="false">
      <el-dialog title="Add Group Item" :visible.sync="showModal" width="40%">
        <form>
          <p
            v-show="errorGroup"
            class="text-danger text-center font-weight-bold"
          >
            Group Name, and Devices ID are required!
          </p>

          <arnergy-dynamic
            v-model="form.groupID"
            label="Select Group"
            :items="groups"
            @subgroup="getSubgroupss"
          />

          <div v-show="form.groupID" class="form-check ml-3">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              v-model="form.status"
              id="defaultCheck1"
            />
            <label class="form-check-label" for="defaultCheck1">
              Do you want to add device to Subgroup?
            </label>
          </div>
          <br />
          <div v-show="form.status">
            <arnergy-select
              v-model="form.subgroup"
              label="Subgroup"
              :items="subgroups"
            />
          </div>
          <br />
          <div>
            <multiselect
              v-model="value"
              :options="devices"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Select Devices You want"
              label="id"
              track-by="id"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </div>
          <br />

          <div class="pt-4 text-right">
            <div v-if="loader" className="text-center">
              <div class="submit-gif">
                <div
                  class="spinner-border"
                  style="width: 3rem; height: 3rem;"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-else>
              <button class="btn btn-primary" @click="submityy">
                Create GroupItems
              </button>
            </div>
          </div>
        </form>
      </el-dialog>
    </transition>

    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>New User</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Group Devices</h2>
        <can I="create" a="user">
          <span style="display: flex; align-items: center;">
            <button
              class="btn btn-primary"
              to="/user/new"
              @click="showModal = true"
            >
              Add Device
            </button>
          </span>
        </can>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <GroupIteminfo />
            </can>
            <el-tabs v-model="activeTab">
              <!-- <can I="read" a="user">
                <el-tab-pane label="User List" name="user_list">
                  <Users/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="device">
                <el-tab-pane label="User Devices" name="user_devices">
                  <Devices/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="wallet">
                <el-tab-pane label="Transaction History" name="transaction_history">
                  <transaction-histories/>
                </el-tab-pane>
              </can>-->
              <!-- <can I='read' a='user'>
                  <el-tab-pane title="User Role Management">
                  <user-role/>
                  </el-tab-pane>
              </can>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupIteminfo from "../user-mgt/GroupIteminfo";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import userRole from "../users/allow";
import ModalMain from "../kitchen/Onboarding/ModalMain.vue";
import ArnergyInput from "../kitchen/ArnergyInput.vue";
import ArnergySelect from "../kitchen/ArnergySelect.vue";
import ArnergyDynamic from "../kitchen/AnergySelectDynamic.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { mapGetters } from "vuex";
import VueSweetalert2 from "vue-sweetalert2";
import Vue from "vue";
import "sweetalert2/dist/sweetalert2.min.css";

import {
  Select,
  Option,
  OptionGroup,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    GroupIteminfo,
    Devices,
    transactionHistories,
    userRole,
    ArnergyInput,
    ArnergySelect,
    Multiselect,
    VueSweetalert2,
    ArnergyDynamic,
    ModalMain
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal: false,
      errorInfo: "",
      loader: false,
      errorGroup: false,
      form: {
        groupID: null,
        subgroup: null,
        status: false
      },
      devices: [{ id: null }],
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      value: [],

      formErrors: {
        name: "",
        description: ""
      },

      value: ""
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getGroups",
      "getSubgroups",
      "getGroupItems",
      "getDummy",
      "getDevices"
    ])
  },
  methods: {
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    submityy(e) {
      e.preventDefault();
      console.log("gggg");
      const HTTP = this.$httpUtils.instance;
      // this.formErrors = this.validateInputs();
      console.log({ form: this.form });
      const data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        deviceid: this.value
      };
      console.log(data);
      if (data.groupid && data.subgroupid && data.deviceid) {
        HTTP.post("/groupItems/addGroupItems", data)
          .then(res => {
            if (res.data) {
              this.showModal = false;
              this.showAlert();
              this.loader = false;
              this.fetchGroupitems();
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.errorGroup = true;
        setTimeout(() => (this.errorGroup = false), 1500);
      }
    },
    validateInputs() {
      const formErrors = [];

      //
      for (let [field, value] of Object.entries(this.form)) {
        value = value + "";
        if (
          value != null &&
          value !== "" &&
          value !== Number.isInteger(value)
        ) {
          value = value.trim();
        } else {
          formErrors[field] = `${this.capitalizeFirstLetter(
            field
          )} are required.`;
        }

        // switch (field) {
        //   case 'bank':
        //     if (value === 'null' || value === '') {
        //       formErrors[field] = ``;
        //     }
        //     break
        //   case 'accountNo':
        //     if (value === 'null' || value === '') {
        //       formErrors[field] = 'Account Number cannot be empty.'
        //     }
        //     break
        //   case 'dateRange':
        //     if (value === 'null' || value === '') {
        //       formErrors[field] = 'Date range cannot be empty.'
        //     }
        //     break
        //   default:
        //     break
        // }
      }
      return formErrors;
    },

    sub(e) {
      e.preventDefault();
      const data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        deviceid: this.value
      };
      const HTTP = this.$httpUtils.instance;
      if (data.groupid && data.deviceid) {
        this.loader = true;
        HTTP.post("/groupItems/addGroupItems", data)
          .then(res => {
            if (res.data) {
              this.showModal = false;
              this.showAlert();
              this.loader = false;
              this.fetchGroupitems();
              this.showModal = false;
              this.value = "";
              this.form.groupID = null;
              this.form.subgroup = null;
              this.loader = false;
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.errorGroup = true;
        setTimeout(() => (this.errorGroup = false), 1500);
      }
    },
    closeModal() {
      this.showModal = false;
      this.value = "";
      this.form.groupID = false;
      this.form.status = false;
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "Group Items Created Successfully",
        icon: "success",
        width: "550px"
      });
    },
    fetchGroupitems() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/groupItems/getGroupItems
`;
      HTTP.post(url)
        .then(response => {
          const list = response.data;
          this.$store.commit("saveGroupItems", list);

          // console.log(this.getUserById(1))
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    async getSubgroupss(id) {
      console.log({ id });
      const HTTP = this.$httpUtils.instance;
      let formData = new FormData();
      formData.append("groupid", id);
      let res = await HTTP.post(
        "/customerSubGroups/getCustomerSubGroupByGroupId",
        formData
      )
        .then(res => {
          this.subgroups = res.data
            .map(item => {
              return {
                id: item.id,
                name: item.subgroupname
              };
            })
            .sort((a, b) => {
              return a.name > b.name ? 1 : -1;
            });
        })
        .catch(e => {
          //
        });
      // parse for "arnergy-select" us
    },

    async fetchDevices() {
      const HTTP = this.$httpUtils.instance;
      const filter = JSON.stringify({
        where: {
          and: [
            { CID: { neq: null } },
            {
              or: [
                { status: "commissioned" },
                { status: "completed" },
                { status: "scheduled" },
                { status: "requested" }
              ]
            }
          ]
        }
      });
      let res = await HTTP.get(`/installations?filter=${filter}`);

      // parse for "arnergy-select" use
      return res.data
        .map(item => {
          return {
            id: item.CID || item.solarKitIds
          };
        })
        .sort((a, b) => {
          return a.cid > b.cid ? 1 : -1;
        });
    }
  },
  async mounted() {
    this.devices = await this.fetchDevices();

    this.groups = this.getGroups
      .map(item => {
        return {
          id: item.id,
          name: item.groupname
        };
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
  }
};
</script>

<style lang="scss" scoped>
.close-btn {
  color: orangered;
  font-size: 16px;
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/GroupItem.vue